export function formatDateTime(dateString: string | null): string {
  if (!dateString) return "Never";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  });
}

export function getThresholdStyle(percent: number): string {
  if (percent >= 80) return "bg-green-100 text-green-800 border-green-300";
  if (percent >= 50) return "bg-yellow-100 text-yellow-800 border-yellow-300";
  return "bg-red-100 text-red-800 border-red-300";
}

export function getThresholdCoverageStyle(percent: number): string {
  if (percent >= 80) return "text-green-700 bg-green-50";
  if (percent >= 50) return "text-yellow-700 bg-yellow-50";
  return "text-red-700 bg-red-50";
}

export function extractId(resourceName: string): string {
  const parts = resourceName.split("/");
  return parts[parts.length - 1] || resourceName;
}

export function withIds<T>(items: T[]): (T & { _id: string })[] {
  return items.map((item) => ({ ...item, _id: crypto.randomUUID() }));
}

export function addToSet<T>(
  setter: React.Dispatch<React.SetStateAction<Set<T>>>,
  value: T,
): void {
  setter((prev) => new Set(prev).add(value));
}

export function removeFromSet<T>(
  setter: React.Dispatch<React.SetStateAction<Set<T>>>,
  value: T,
): void {
  setter((prev) => {
    const next = new Set(prev);
    next.delete(value);
    return next;
  });
}

export function validateIconFile(
  file: File,
  onValid: (base64: string, previewUrl: string) => void,
  onError: (message: string) => void,
): void {
  if (file.type !== "image/png") {
    onError("Only PNG files are accepted");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const img = new Image();
    img.onload = () => {
      if (img.width !== img.height) {
        onError(`Icon must be square (got ${img.width}x${img.height})`);
        return;
      }
      if (img.width < 72 || img.width > 1200) {
        onError(`Icon must be 72–1200px (got ${img.width}px)`);
        return;
      }
      const base64 = (reader.result as string).split(",")[1];
      onValid(base64, reader.result as string);
    };
    img.src = reader.result as string;
  };
  reader.readAsDataURL(file);
}
